const configTemplate = {
  ROOT: {
    type: {
      resolvedName: 'Container',
    },
    isCanvas: true,
    props: {
      padding: 5,
      isBorder: false,
      size: '100%',
      id: 'rootCanvas',
    },
    displayName: 'Container',
    custom: {},
    hidden: false,
    nodes: ['Wuvew65gfd'],
    linkedNodes: {},
  },
  Wuvew65gfd: {
    type: {
      resolvedName: 'Input',
    },
    isCanvas: false,
    props: {
      isEditable: true,
      size: '100%',
      isLabel: true,
      label: '',
      isMultiline: true,
      format: '',
      isMandatory: false,
      isShared: false,
      dictionaryType: 1,
      dataKey: 'Note',
      dataType: 2,
      dataBlockFieldId: 8,
    },
    displayName: 'Input',
    custom: {},
    parent: 'ROOT',
    hidden: false,
    nodes: [],
    linkedNodes: {},
  },
};

// Create UI config for data block field
export function getConfigForField(
  configString: string,
  fieldName: string,
  isTable: boolean,
) {
  const config = JSON.parse(configString);
  const displayName = isTable ? 'Table' : 'Input';
  for (const i in config) {
    if (
      config[i]['displayName'] === displayName &&
      config[i]['props']['dataKey'] === fieldName
    ) {
      configTemplate['Wuvew65gfd']['props'] = config[i]['props'];
      configTemplate['Wuvew65gfd']['type']['resolvedName'] = displayName;
      configTemplate['Wuvew65gfd']['displayName'] = displayName;
      configTemplate['Wuvew65gfd']['props']['size'] = '100%';
      return JSON.stringify(configTemplate);
    }
  }
  return null;
}

export function isEmpty(value: any) {
  if (value === undefined || value === null || value.length === 0) {
    return true;
  }
  return false;
}

export function isObjectEmpty(value: any) {
  return (
    value === undefined || value === null || Object.keys(value).length === 0
  );
}
